import { Translation } from '../types';

export const hu: Translation = {
  common: {
    loading: 'Betöltés...',
    error: 'Hiba',
    cancel: 'Mégsem',
    save: 'Mentés',
    close: 'Bezárás',
    search: 'Keresés',
    reload: 'Újratöltés',
    logout: 'Kijelentkezés',
    dashboard: 'Vezérlőpult',
    products: 'Termékek',
    settings: 'Beállítások',
    language: 'Nyelv',
    businessHours: 'Nyitvatartás',
    back: 'Vissza',
    selectAll: 'Összes kijelölése',
    deselectAll: 'Kijelölés megszüntetése',
    success: 'Siker',
    selected: 'Kiválasztva',
    confirm: 'Megerősítés',
    required: 'Kötelező',
    requiredMarker: '*',
    previous: 'Előző',
    next: 'Következő',
    allRightsReserved: 'Minden jog fenntartva.',
  },
  auth: {
    login: 'Bejelentkezés',
    email: 'E-mail cím',
    password: 'Jelszó',
    loginButton: 'Bejelentkezés',
    loggingIn: 'Bejelentkezés folyamatban...',
    loginSuccess: 'Sikeres bejelentkezés',
    loginError: 'Helytelen e-mail cím vagy jelszó',
    invalidEmail: 'Kérjük, adjon meg egy érvényes e-mail címet',
    requiredFields: 'Kérjük, töltsön ki minden kötelező mezőt',
    demoAccount: 'Demó fiók:',
    loginDescription: 'Kérjük, adja meg fiókadatait a bejelentkezéshez',
    welcomeMessage: 'Üdvözöljük a B2B rendelési rendszerben',
    // Registration
    register: 'Regisztráció',
    createAccount: 'Fiók létrehozása',
    confirmPassword: 'Jelszó megerősítése',
    passwordRequirements: 'A jelszónak legalább 8 karakter hosszúnak kell lennie, és tartalmaznia kell kis- és nagybetűt, számot és speciális karaktert',
    passwordsDoNotMatch: 'A jelszavak nem egyeznek',
    registrationSuccess: 'A regisztráció sikeres',
    registrationDescription: 'Regisztráljon üzleti fiókot',
    alreadyHaveAccount: 'Már van fiókja?',
    signIn: 'Jelentkezzen be',
    dontHaveAccount: 'Nincs még fiókja?',
    creatingAccount: 'Fiók létrehozása...',
    registrationNote: 'Megjegyzés:',
    registrationNotePoints: {
      erpLinking: 'Ha már rendelkezik üzleti fiókkal, e-mail címe automatikusan összekapcsolásra kerül',
      companyEmail: 'Kérjük, használja céges e-mail címét a regisztrációhoz',
      contactSupport: 'Vegye fel a kapcsolatot az ügyfélszolgálattal, ha segítségre van szüksége a regisztrációhoz'
    },
    b2bUsers: 'Üzleti felhasználók:',
    registeredEmail: 'Regisztrált e-mail cím',
    registeredPassword: 'A regisztrációkor megadott jelszó',
    b2bCustomerRequired: 'Ez az e-mail cím nincs regisztrálva B2B ügyfélként. Kérjük, először vegye fel a kapcsolatot az értékesítési osztállyal az üzleti kapcsolat létrehozásához.',
    b2bVerificationError: 'Nem sikerült ellenőrizni a B2B ügyfélstátuszt. Kérjük, vegye fel a kapcsolatot az ügyfélszolgálattal.',
    // Password Reset
    passwordReset: 'Jelszó visszaállítása',
    passwordResetDescription: 'Adja meg e-mail címét egy ideiglenes jelszó kéréséhez',
    getTemporaryPassword: 'Ideiglenes jelszó kérése',
    processing: 'Feldolgozás...',
    passwordResetComplete: 'Jelszó visszaállítása kész',
    temporaryPasswordGenerated: 'Az ideiglenes jelszó létrehozva',
    temporaryPassword: 'Ideiglenes jelszó',
    backToLogin: 'Vissza a bejelentkezéshez',
    securityNotice: 'Biztonsági figyelmeztetés:',
    securityNotePoints: {
      keepSecret: 'Ne ossza meg az ideiglenes jelszót másokkal',
      changeAfterLogin: 'Bejelentkezés után feltétlenül változtassa meg jelszavát',
      expires24Hours: 'Az ideiglenes jelszó 24 óra múlva lejár'
    },
    resetNote: 'Megjegyzés:',
    resetNotePoints: {
      registeredEmail: 'Adja meg a regisztrált e-mail címét',
      passwordDisplayed: 'Az ideiglenes jelszó a képernyőn fog megjelenni',
      changeRequired: 'Bejelentkezés után jelszómódosítás szükséges'
    },
    copied: 'Másolva',
    copySuccessMessage: 'Ideiglenes jelszó a vágólapra másolva.',
    forgotPassword: 'Elfelejtette a jelszavát?',
    // Password Reset Email Request
    sendResetLink: 'Visszaállító link küldése',
    sendingEmail: 'E-mail küldése...',
    emailSent: 'E-mail elküldve',
    emailSentMessage: 'Ha ez az e-mail cím szerepel a rendszerünkben, hamarosan kapni fog egy visszaállító linket.',
    emailNotSent: 'E-mail nem lett elküldve',
    emailSentInfo: 'Ellenőrizze a beérkező leveleit és a spam mappát',
    checkEmail: 'Ellenőrizze e-mailjét',
    emailInstructions: 'A jelszó visszaállításához szükséges utasításokat elküldtük',
    nextSteps: 'Következő lépések:',
    nextStepsList: {
      checkInbox: 'Ellenőrizze a beérkező leveleit és a spam mappát',
      clickLink: 'Kattintson az e-mailben található visszaállító linkre',
      linkExpires: 'A link 24 óráig érvényes',
      contactSupport: 'Lépjen kapcsolatba az ügyfélszolgálattal, ha nem kapja meg az e-mailt',
      rateLimitInfo: 'Óránként legfeljebb 3 kérés engedélyezett'
    },
    // Password Reset Completion
    resetLinkSent: 'Visszaállító link elküldve',
    resetSuccess: 'A jelszó sikeresen visszaállítva',
    passwordUpdated: 'Jelszó frissítve',
    passwordUpdateMessage: 'A jelszavát sikeresen frissítettük. Most már bejelentkezhet az új jelszavával.',
    loginWithNewPassword: 'Bejelentkezés új jelszóval',
    // Reset Token Page
    resetToken: 'Jelszó visszaállítása',
    invalidToken: 'Érvénytelen visszaállító token',
    expiredToken: 'A visszaállító token lejárt',
    tokenValid: 'A visszaállító token érvényes',
    newPassword: 'Új jelszó',
    confirmNewPassword: 'Új jelszó megerősítése',
    updatePassword: 'Jelszó frissítése',
    updatingPassword: 'Jelszó frissítése...',
    passwordMismatch: 'A jelszavak nem egyeznek',
    resetInstructions: 'Adja meg új jelszavát a visszaállítás befejezéséhez',
  },
  accountInfo: {
    title: 'Fiókadatok',
    loading: 'Fiókadatok betöltése...',
    error: 'Hiba',
    errorMessage: 'Nem sikerült lekérni a fiókadatokat',
    back: 'Vissza',
    basicInfo: 'Alapvető információk',
    name: 'Név',
    email: 'E-mail cím',
    contactId: 'Knitido ügyfélazonosító',
    contactNumber: 'Kapcsolattartási szám',
    noInfo: 'Nincs adat',
    companyInfo: 'Céginformációk',
    company: 'Cégnév',
    position: 'Pozíció',
    vatId: 'Adószám',
    billingAddress: 'Számlázási cím',
    deliveryAddress: 'Szállítási cím',
    addressInfo: 'Címadatok',
    billingDescription: 'Cím a számlákhoz és szerződéses dokumentumokhoz',
    deliveryDescription: 'Alapértelmezett szállítási cím a termékek kiszállításához',
    sameAsBilling: '※ Megegyezik a számlázási címmel',
    sameAsDelivery: '※ Megegyezik a szállítási címmel',
    companyName: 'Cégnév',
    contactPerson: 'Kapcsolattartó személy',
    address: 'Cím',
    phoneNumber: 'Telefonszám',
    billingUsage: 'Számlákhoz, szerződésekhez és egyéb fontos dokumentumokhoz használjuk',
    deliveryUsage: 'A rendelt termékek alapértelmezett szállítási címe',
    alsoUsedForDelivery: 'Szállítási címként is használatban',
    accountType: 'Fiók típusa',
    addressId: 'Címazonosító',
    // Address editing functionality
    edit: 'Szerkesztés',
    editDeliveryAddress: 'Szállítási cím szerkesztése',
    editDeliveryDescription: 'Frissítse szállítási címének adatait',
    newDeliveryAddress: 'Új szállítási cím hozzáadása',
    newDeliveryDescription: 'Adja meg az új szállítási cím adatait',
    noDeliveryAddress: 'Nincs beállítva szállítási cím',
    success: 'Siker',
    addressUpdated: 'Szállítási cím frissítve',
    updateError: 'Nem sikerült frissíteni a szállítási címet',
    requiredFields: 'Kérjük, töltsön ki minden kötelező mezőt',
    firstName: 'Keresztnév',
    lastName: 'Vezetéknév',
    streetAddress: 'Utca, házszám',
    streetAddress2: 'Utca, házszám 2',
    city: 'Város',
    country: 'Ország',
    selectCountry: 'Válasszon országot...',
    searchCountry: 'Ország keresése...',
    noCountryFound: 'Nincs találat.',
    postalCode: 'Irányítószám',
    companyNamePlaceholder: 'Adja meg a cég nevét',
    firstNamePlaceholder: 'Keresztnév',
    lastNamePlaceholder: 'Vezetéknév',
    streetAddressPlaceholder: 'Adja meg a címet',
    streetAddress2Placeholder: 'Emelet, ajtó, stb.',
    cityPlaceholder: 'Adja meg a várost',
    postalCodePlaceholder: 'Adja meg az irányítószámot',
    billingNotEditable: 'A számlázási cím nem szerkeszthető.',
    billingContactSupport: 'Módosításért lépjen kapcsolatba az ügyfélszolgálattal.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} szállítási cím',
    noDeliveryAddresses: 'Nincs regisztrált szállítási cím',
    defaultAddress: 'Alapértelmezett',
    selectDeliveryAddress: 'Válasszon szállítási címet',
    addNewAddress: 'Új cím hozzáadása',
    editAddress: 'Cím szerkesztése',
    deleteAddress: 'Cím törlése',
    confirmDelete: 'Törlés megerősítése',
    confirmDeleteMessage: 'Biztosan törölni szeretné ezt a címet? Ez a művelet nem vonható vissza.',
    addressAddedSuccess: 'Szállítási cím hozzáadva',
    addressDeletedSuccess: 'Szállítási cím törölve',
    deleteError: 'Nem sikerült törölni a szállítási címet',
    saving: 'Mentés...',
    cancel: 'Mégsem',
    saveChanges: 'Változtatások mentése',
    selectedDeliveryAddress: 'Kiválasztott szállítási cím',
  },
  dashboard: {
    title: 'Üzleti Partner',
    subtitle: 'Termékrendelési rendszer',
    welcome: 'Üdvözöljük,',
    welcomeMessage: 'Üdvözöljük az üzleti partnerek rendelési rendszerében. Itt adhatja le rendeléseit.',
    productCatalog: 'Termékkatalógus',
    productCatalogDesc: 'Böngésszen és rendeljen elérhető termékeinkből',
    viewProducts: 'Termékek megtekintése',
    orderHistory: 'Rendelési előzmények',
    orderHistoryDesc: 'Korábbi rendelések megtekintése',
    accountSettings: 'Fiók beállításai',
    accountSettingsDesc: 'Fiókadatok kezelése',
    comingSoon: 'Hamarosan',
    infoTitle: 'Használati útmutató',
    orderingInfo: 'Termékrendelés',
    orderingDesc: 'Válasszon termékeket a katalógusból, majd adja meg a méretet és színt. A készletinformációk valós időben érhetők el.',
    supportInfo: 'Támogatás',
    supportDesc: 'Kérdés esetén vegye fel velünk a kapcsolatot.',
    viewOrderHistory: 'Előzmények megtekintése',
    viewOrders: 'Rendelések megtekintése',
    accountInfo: 'Fiókadatok',
    accountInfoDesc: 'Fiókrészletek megtekintése',
    viewDetails: 'Részletek megtekintése',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Hétfő-Péntek 9:00 - 15:00 CET',
    bulkImportDesc: 'Rendelések importálása Excel/CSV fájlból',
    importOrders: 'Rendelések importálása',
  },
  products: {
    title: 'Terméklista',
    subtitle: 'Üzleti Partner',
    searchPlaceholder: 'Keresés terméknév vagy SKU alapján...',
    productId: 'Termékazonosító',
    addToCart: 'Kosárba',
    selectVariation: 'Válasszon variációt',
    price: 'Ár',
    priceNetNotice: 'Minden ár nettó (ÁFA nélkül)',
    stock: 'Készlet',
    color: 'Szín',
    newProducts: 'Új termékek',
    newProductBadge: 'ÚJ',
    size: 'Méret',
    quantity: 'Mennyiség',
    total: 'Összesen',
    cart: 'Kosár',
    checkout: 'Pénztár',
    csvMode: 'CSV gyors mód',
    csvInfo: 'Termékadatok CSV-ből betöltve',
    csvUploadDate: 'CSV feltöltés dátuma:',
    stockNote: '※ A készletinformáció a termékvariációk kiválasztásakor frissül',
    noProducts: 'Nincs találat',
    noProductsDesc: 'Módosítsa a keresési feltételeket vagy töltsön fel CSV fájlt a gyorsabb működésért.',
    retry: 'Próbálja újra',
    pagination: 'elem',
    variations: 'variáció',
    stockFetchError: 'Készletlekérdezési hiba',
    stockFetchFailed: 'A készlet lekérdezése sikertelen',
    stockFetchFailedDesc: 'Nem sikerült lekérni a készletinformációkat. A CSV készletadatok jelennek meg.',
    stockFetched: 'Készletinformáció lekérve',
    totalStock: 'Teljes készlet',
    noStockAll: 'Egyik variáció sincs raktáron',
    noStockData: 'Nincs visszaküldött készletadat',
    stockFetchErrorDesc: 'Hiba történt a készletinformációk lekérése során',
    selectionError: 'Kiválasztási hiba',
    enterQuantity: 'Kérjük, adjon meg egy mennyiséget',
    addedToCart: 'Kosárba helyezve',
    typesAdded: ' terméktípus hozzáadva',
    addToCartError: 'Hiba a kosárba adáskor',
    addToCartErrorDesc: 'Kérjük, próbálja újra',
    loadingStock: 'Készletinformáció betöltése',
    csvDataInfo: 'CSV adatokat mutat (nem a tényleges készletet)',
    invalidDataFormat: 'A termékadatok formátuma érvénytelen',
    loadFailed: 'Nem sikerült betölteni a termékadatokat',
    csvUploadComplete: 'CSV feltöltés kész',
    csvLoadedDesc: ' termékadat betöltve. A készletinformáció a termékek kiválasztásakor kerül lekérésre.',
    searchTitle: 'Termékkeresés',
    loadingProducts: 'Termékadatok betöltése',
    noProductsCsv: 'Nem található termék a CSV adatokban. Kérjük, módosítsa a keresési feltételeket.',
    paginationDisplay: ' megjelenítve',
    previous: 'Előző',
    next: 'Következő',
    selectionSummary: 'Kiválasztás összesítése',
    selectedQuantity: 'Kiválasztott mennyiség',
    items: ' elem',
    viewDetails: 'Részletek megtekintése',
    productImage: 'Termékkép',
    correspondingVariations: 'Kapcsolódó variációk',
    clickToEnlarge: 'Kattintson a nagyításhoz',
    productIdLabel: 'Termékazonosító',
    colorLabel: 'Szín',
    filterByCategory: 'Szűrés kategória szerint',
    allProducts: 'Minden termék',
    applyFilters: 'Szűrők alkalmazása',
    clearFilters: 'Szűrők törlése',
    filters: 'Szűrők',
    clearAll: 'Összes törlése',
  },
  categories: {
    category_21: 'Ujjasszokni',
    category_23: 'Nem kategorizált',
    category_24: 'Testviselet',
    category_29: 'B2B termékek',
  },
  productDetail: {
    title: 'Termékrészletek',
    backToProducts: 'Vissza a termékekhez',
    productNotFound: 'A termék nem található',
    productNotFoundDesc: 'A megadott termék nem létezik vagy törölve lett.',
    loading: 'Termék betöltése...',
    imageLoadError: 'Nem sikerült betölteni a képeket',
    noImages: 'Nincs elérhető kép',
    productDescription: 'Termékleírás',
    colors: 'Színek',
    sizes: 'Méretek',
    colorCount: 'szín',
    sizeCount: 'méret',
    variationCount: 'variáció',
    selectVariation: 'Variációk kiválasztása',
    descriptionLanguageNote: '※ A termékleírások csak angol vagy német nyelven érhetők el',
  },
  colors: {
    schwarz: 'Fekete',
    weiß: 'Fehér',
    grau: 'Szürke',
    rot: 'Piros',
    blau: 'Kék',
    grün: 'Zöld',
    gelb: 'Sárga',
    rosa: 'Rózsaszín',
    lila: 'Lila',
    braun: 'Barna',
    orange: 'Narancs',
    beige: 'Bézs',
    navy: 'Tengerészkék',
    dunkelblau: 'Sötétkék',
    hellblau: 'Világoskék',
    dunkelgrau: 'Sötétszürke',
    hellgrau: 'Világosszürke',
    bordeaux: 'Bordó',
    türkis: 'Türkiz',
    khaki: 'Khaki',
    mint: 'Menta',
    violett: 'Ibolya',
    anthrazit: 'Antracit',
    blaugrau: 'Kékeszürke',
    burgunderrot: 'Burgundi vörös',
    elfenbein: 'Elefántcsont',
    karminrot: 'Kárminpiros',
    neongrün: 'Neonzöld',
    gelbgrün: 'Sárgászöld',
    pistazie: 'Pisztácia',
    // English color names (used in Product ID 237, etc.)
    blue: 'Kék',
    ivory: 'Elefántcsont',
    green: 'Zöld',
    gold: 'Arany',
    red: 'Piros',
  },
  checkout: {
    title: 'Pénztár',
    cartReview: 'Rendelés áttekintése',
    orderSummary: 'Rendelés összesítése',
    shippingInfo: 'Szállítási információk',
    billingInfo: 'Számlázási információk',
    orderNotes: 'Megjegyzés a rendeléshez',
    orderNotesPlaceholder: 'Különleges kérések vagy megjegyzések...',
    contactPerson: 'Kapcsolattartó személy',
    phoneNumber: 'Telefonszám',
    email: 'E-mail cím',
    company: 'Cég',
    address: 'Cím',
    city: 'Város',
    postalCode: 'Irányítószám',
    country: 'Ország',
    deliveryDate: 'Szállítási dátum',
    urgentDelivery: 'Expressz szállítás (3-5 munkanap)',
    standardDelivery: 'Normál szállítás (7-10 munkanap)',
    placeOrder: 'Rendelés elküldése',
    backToCart: 'Vissza a termékválasztáshoz',
    requiredField: 'Kötelező mező',
    orderTotal: 'Rendelés összege',
    subtotal: 'Részösszeg',
    priceNetNotice: 'Minden ár nettó (ÁFA nélkül)',
    stockReservationNotice: 'A készletfoglalás a rendelés visszaigazolása után történik.',
    stockCheckError: 'Készletellenőrzési hiba',
    stockCheckErrorDesc: 'Hiba történt a készlet ellenőrzése során. Kérjük, próbálja újra.',
    shipping: 'Szállítás',
    shippingCost: 'Szállítási költség',
    tax: 'ÁFA',
    orderSuccess: 'Sikeres rendelés',
    orderSuccessMessage: 'A rendelését elküldtük. Rendelésszám: {orderNumber}',
    orderNumber: 'Rendelésszám',
    thankYou: 'Köszönjük a rendelését!',
    orderConfirmation: 'A rendelését elküldtük.',
    orderProcessing: 'Munkatársaink ellenőrzik a rendelést, majd e-mailben küldjük a visszaigazolást.',
    orderProcessingMessage: 'A rendelését elküldtük. Munkatársaink ellenőrzik, majd e-mailben küldjük a visszaigazolást.',
    continueShopping: 'Vásárlás folytatása',
    emptyCart: 'Az Ön kosara üres',
    emptyCartMessage: 'Kérjük, helyezzen termékeket a kosárba a folytatáshoz',
    stockWarning: 'Készletfigyelmeztetés',
    stockWarningDesc: 'Néhány tételből nincs elegendő készlet. Kérjük, módosítsa a mennyiségeket.',
    stockError: 'Készlethiba',
    stockErrorDesc: 'Vannak tételek, amelyekből nincs elegendő készlet. Kérjük, módosítsa a mennyiségeket.',
    refreshStock: 'Készlet frissítése',
    stockUpdated: 'Készlet frissítve',
    stockUpdatedDesc: 'A készlet frissült - {changed} tétel változott',
    stockCheckDesc: 'A leltárral való összehasonlítás eredményeinek megjelenítése',
    stockOk: 'Készlet OK',
    stockShortage: 'Készlethiány',
    requestedQty: 'Kért mennyiség',
    currentStock: 'Jelenlegi készlet',
    stockShortageMsg: 'Nincs elegendő készlet. Kérjük, módosítsa a mennyiséget.',
    stockIssueWarning: 'A rendelést nem lehet megerősíteni készletproblémák miatt.',
    stockDataMissing: 'Készletadatok lekérése folyamatban. Kérjük, várjon.',
    outOfStock: 'Elfogyott.',
    maxAvailable: 'Maximum',
    autoRestored: 'Kosár visszaállítva',
    autoRestoredDesc: 'Az előző munkamenetből visszaállítottuk az elemeket',
    maxQuantityReached: 'Elérte a maximális készletmennyiséget.',
    // ERP Contact Search
    contactSearch: 'Ügyfélkapcsolat keresése',
    contactSearchDesc: 'Adja meg a megrendelő e-mail címét a kapcsolatfelvételi adatok lekéréséhez',
    emailAddress: 'E-mail cím',
    searchButton: 'Keresés',
    searching: 'Keresés folyamatban',
    contactFound: 'Kapcsolat megtalálva',
    contactNotFound: 'Kapcsolat nem található',
    contactId: 'Knitido ügyfélazonosító',
    companyName: 'Cég',
    contactPersonLabel: 'Kapcsolattartó',
    addressesFound: 'Talált címek',
    addressType: 'Típus',
    addressBilling: 'Számlázási cím',
    addressDelivery: 'Szállítási cím',
    vatSourceCompany: 'Cégadatok',
    vatSourceBilling: 'Számlázás',
    vatSourceDelivery: 'Szállítás',
    addressOther: 'Egyéb',
    addressDetails: 'Cím',
    loadingAddresses: 'Címadatok betöltése...',
    addressRetrieved: 'Címadatok lekérve',
    addressNotFound: 'Címadatok nem találhatók',
    addressNotFoundDesc: 'Nincs regisztrált címadat. Kérjük, adja meg manuálisan.',
    addressError: 'Címlekérdezési hiba',
    addressErrorDesc: 'Nem sikerült lekérni a címadatokat.',
    contactNotConfirmed: 'Ügyfélkapcsolat nincs megerősítve',
    contactNotConfirmedDesc: 'Kérjük, adjon meg egy e-mail címet és keressen rá a kapcsolatra.',
    searchContact: 'Kapcsolat keresése',
    inputError: 'Beviteli hiba',
    inputErrorDesc: 'A szállítási információ hiányos. Kérjük, ellenőrizze.',
    processing: 'Feldolgozás...',
    erpContactSearch: 'Ügyfélkapcsolat keresése',
    contactSearchError: 'Az e-mail cím nem egyezik egyetlen regisztrált kapcsolattal sem.',
    // Product Images Toggle
    showProductImages: 'Termékképek megjelenítése',
    showProductImagesDesc: 'Termékképek megjelenítése a jobb áttekinthetőség érdekében (növelheti a betöltési időt)',
    // System Registration Info
    systemRegistrationInfo: 'Az Ön ügyfélinformációi',
    editShippingAddress: 'Szállítási cím szerkesztése',
    systemRegistrationInfoDesc: 'Az Ön regisztrált cégadatai. Kérjük, vegye fel a kapcsolatot képviselőjével, ha frissíteni szeretné a számlázási címet.',
    // Order Summary
    regularPrice: 'Normál nagykereskedelmi ár',
    offeredPrice: 'Ajánlati ár',
    discount: 'Kedvezmény',
    b2bCustomer: 'B2B ügyfél',
    pattern: 'Minta',
    specialPriceApplied: 'Akciós ár alkalmazva',
    customerClassification: 'Ügyfélbesorolás',
    paymentCondition: 'Fizetési feltételek',
    invoice: 'Számla (NETTO 30)',
    prepayment: 'Előrefizetés',
    paymentMethod: 'Fizetési mód',
    invoicePayment: 'Számlás fizetés',
    estimatedSubtotal: 'Becsült részösszeg',
    estimatedTotal: 'Becsült végösszeg',
    orderSummaryDisclaimer: 'Az itt feltüntetett árak becslések. Rendelése beérkezése után felülvizsgáljuk azt, és e-mailben küldünk egy kötelező érvényű visszaigazolást a végleges árakkal, szállítási költségekkel és adókkal.',
    searchError: 'Keresési hiba',
    searchErrorDesc: 'Hiba történt a kapcsolatkeresés során.',
    confirmDeleteItem: 'Tétel eltávolítása',
    itemDeleted: 'Tétel eltávolítva',
    confirmDeleteItemDesc: 'Biztosan eltávolítja a következő tételt a kosárból?',
    deleteConfirm: 'Eltávolítás',
    contactNotes: 'Kapcsolattartási megjegyzések',
    contactNotesDesc: 'Van kérdése vagy különleges kérése? Tudassa velünk (opcionális)',
    contactNotesLabel: 'Üzenet',
    contactNotesPlaceholder: 'pl.: Termékkel kapcsolatos kérdés, speciális igények stb.',
    characters: 'karakter',
    contactIdLabel: 'Knitido ügyfélazonosító',
    companyLabel: 'Cég',
    personLabel: 'Kapcsolattartó',
    emailLabel: 'E-mail',
    addressTypeLabel: 'Típus',
    destinationLabel: 'Célállomás',
    // Shipping Form
    shippingTitle: 'Szállítási információk',
    shippingDesc: 'Adja meg a termékek szállítási címét',
    companyRequired: 'Cég *',
    contactPersonRequired: 'Kapcsolattartó személy *',
    emailRequired: 'E-mail cím *',
    phoneRequired: 'Telefonszám *',
    addressRequired: 'Cím 1 *',
    address2: 'Cím 2 (Épület/Szoba)',
    postalCodeRequired: 'Irányítószám *',
    cityRequired: 'Város *',
    countryRequired: 'Ország *',
    selectCountry: 'Válasszon országot',
    shippingMethodRequired: 'Szállítási mód *',
    selectShippingMethod: 'Válasszon szállítási módot',
    urgentDeliveryOption: 'Expressz szállítás (többletköltséggel)',
    deliveryNotes: 'Szállítási megjegyzések',
    deliveryNotesPlaceholder: 'Adja meg a szállítási időpreferenciákat vagy egyéb kéréseket',
    standardShipping: 'Normál szállítás (3-5 munkanap)',
    expressShipping: 'Expressz szállítás (1-2 munkanap)',
    overnightShipping: 'Másnapi kézbesítés',
    germany: 'Németország',
    austria: 'Ausztria',
    switzerland: 'Svájc',
    japan: 'Japán',
    shippingAddressLabel: 'Szállítási cím',
    changeDeliveryAddress: 'Szállítási cím módosítása',
    selectDeliveryAddress: 'Szállítási cím kiválasztása',
    // Shipping Cost Details
    freeShipping: 'Ingyenes szállítás',
    shippingError: 'Hiba',
    shippingZone: 'Szállítási zóna',
    remainingForFreeShipping: 'Még {amount} az ingyenes szállításhoz',
    moreForFreeShipping: 'még az ingyenes szállításhoz',
    freeShippingProgress: 'Ingyenes szállítás',
    andAboveFreeShipping: 'felett ingyenes szállítás',
    freeShippingAchieved: 'Ingyenes szállítás alkalmazva',
    threshold: 'felett',
    nextShippingTier: 'Következő szállítási kedvezmény',
    moreForDiscount: 'további',
    shippingSavings: 'szállítási megtakarítás',
    orderAmountThreshold: 'rendelési összeg felett',
    specialRegionNotice: 'Különleges szállítási zóna érvényes',
    defaultShippingApplied: 'Alapértelmezett szállítási árak alkalmazva',
    requestedQuantity: 'Kért mennyiség',
    availableQuantity: 'Elérhető mennyiség',
    orderSubmitError: 'Rendelési hiba',
    orderSubmitErrorDesc: 'A rendelés beküldése sikertelen',
    upload: {
      title: 'Excel/CSV rendelés importálása',
      description: 'Töltsön fel egy Excel vagy CSV fájlt a rendelési adatokkal',
      dragDropOrClick: 'Húzza ide a fájlt vagy kattintson a kiválasztáshoz',
      dropHere: 'Húzza ide a fájlt',
      supportedFormats: 'Támogatott formátumok: Excel (.xlsx, .xls) és CSV (.csv)',
      maxSize: 'Maximális fájlméret: {size} MB',
      processFile: 'Fájl feldolgozása',
      processing: 'Fájl feldolgozása...',
      ready: 'Fájl kész az előnézethez',
      readyDescription: 'A fájl feldolgozása megtörtént, készen áll az áttekintésre.',
      preview: 'Előnézet megtekintése',
      errors: {
        fileTooLarge: 'A fájl túl nagy. Maximális méret: {size} MB',
        invalidFileType: 'Érvénytelen fájltípus. Kérjük, töltsön fel Excel vagy CSV fájlt',
        uploadFailed: 'Hiba a fájl feltöltésekor',
      },
    },
    // Loading messages
    loadingPage: 'Oldal betöltése...',
    loadingStock: 'Készlet ellenőrzése...',
    loadingAccount: 'Fiókadatok betöltése...',
    loadingError: 'Hiba történt...',
    loadingData: 'Adatok betöltése',
    // Toast messages
    addressRetrievedTitle: 'Címadatok lekérve',
    addressSetAsDelivery: ' cím beállítva szállítási célként.',
    contactFoundDesc: ' azonosítva.'
  },
  orderHistory: {
    title: 'Rendelési előzmények',
    searchPlaceholder: 'Keresés rendelésszám vagy SKU alapján...',
    noOrders: 'Nincs rendelés',
    noOrdersFound: 'Nem található megfelelő rendelés',
    startShopping: 'Termékek megtekintése',
    orderItems: 'Rendelt tételek',
    viewDetails: 'Részletek',
    reorder: 'Újrarendelés',
    orderDate: 'Rendelés dátuma',
    orderStatus: 'Státusz',
    orderTotal: 'Rendelés összege',
    // Status translations
    statusPending: 'Fizetésre vár',
    statusProcessing: 'Feldolgozás alatt',
    statusConfirmed: 'Megerősítve',
    statusShipped: 'Kiszállítva',
    statusDelivered: 'Kézbesítve',
    statusCancelled: 'Törölve',
    statusReturned: 'Visszaküldve',
    statusRefunded: 'Visszatérítve',
    statusWarranty: 'Garancia',
    statusExchanged: 'Cserélve',
    statusRepair: 'Javítás',
    statusUnknown: 'Ismeretlen',
    statusIncomplete: 'Hiányos',
    statusWaitingPayment: 'Fizetésre vár',
    statusInPreparation: 'Előkészítés alatt',
    statusClearedShipping: 'Szállításra kész',
    statusBeingShipped: 'Szállítás alatt',
    statusOutgoingBooked: 'Kimenő áru lekönyvelve',
    statusReturn: 'Visszáru',
    // Additional UI elements
    itemCount: 'tétel',
    itemCountSingular: 'tétel',
    refreshButton: 'Frissítés',
    errorFetchingOrders: 'Nem sikerült lekérni a rendelési előzményeket',
    // Payment status features
    paymentStatus: 'Fizetési státusz',
    markAsPaid: 'Megjelölés fizetettként',
    unmarkAsPaid: 'Fizetett jelölés törlése',
    paidOn: 'Fizetve ekkor:',
    paymentMarked: 'Fizetve',
    notPaid: 'Nincs fizetve',
    paymentMarkedSuccess: 'Sikeresen megjelölve fizetettként',
    paymentUnmarkedSuccess: 'Fizetett jelölés eltávolítva',
    paymentUpdateError: 'Nem sikerült frissíteni a fizetési státuszt',
    // Payment date dialog
    paymentDateTitle: 'Fizetési adatok megadása',
    paymentDateDescription: 'Adja meg a fizetési adatokat a következő rendeléshez: {orderNumber}',
    paymentDateLabel: 'Fizetés dátuma',
    selectDate: 'Válasszon dátumot',
    paymentDateHelp: 'Válassza ki a banki átutalás dátumát',
    paymentMethodLabel: 'Fizetési mód',
    bankTransfer: 'Banki átutalás',
    invoice: 'Számla',
    otherPayment: 'Egyéb',
    paymentReferenceLabel: 'Átutalás közleménye / Hivatkozási szám',
    paymentReferencePlaceholder: 'pl. Minta János, Átutalás #12345',
    paymentReferenceHelp: 'Adjon meg olyan információt, amely segít az azonosításban a bankszámlakivonaton',
    notesLabel: 'Megjegyzések',
    notesPlaceholder: 'Adjon meg további információt a fizetéssel kapcsolatban',
    // Filter options
    filterByPaymentStatus: 'Szűrés fizetési státusz szerint',
    allOrders: 'Minden rendelés',
    paidOrders: 'Fizetve',
    unpaidOrders: 'Nincs fizetve',
    // Sorting options
    sortBy: 'Rendezés',
    sortByDate: 'Rendelés dátuma',
    sortByPaymentDate: 'Fizetés dátuma',
    sortByAmount: 'Összeg',
    sortByStatus: 'Státusz',
  },
  orderDetails: {
    title: 'Rendelés részletei',
    notFound: 'A rendelés nem található',
    backToHistory: 'Vissza az előzményekhez',
    orderDate: 'Rendelés dátuma',
    orderItems: 'Rendelt tételek',
    deliveryStatus: 'Szállítási státusz',
    estimatedDelivery: 'Becsült kézbesítés',
    deliveredOn: 'Kézbesítve',
    downloadInvoice: 'Számla letöltése',
    statusDelivered: 'Kézbesítve',
    statusShipped: 'Kiszállítva',
    statusConfirmed: 'Megerősítve',
    statusCancelled: 'Törölve',
    errorFetchingDetails: 'Nem sikerült lekérni a rendelés részleteit',
  },
  company: {
    name: 'Üzleti Partner',
    tagline: 'Üzleti Partner Rendszer',
    copyright: '© 2025 Üzleti Partner Rendszer. Minden jog fenntartva.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-mail',
    countries: {
      DE: 'Németország',
      AT: 'Ausztria',
      CH: 'Svájc',
      FR: 'Franciaország',
      IT: 'Olaszország',
      ES: 'Spanyolország',
      NL: 'Hollandia',
      BE: 'Belgium',
      PL: 'Lengyelország',
      SE: 'Svédország',
      NO: 'Norvégia',
      FI: 'Finnország',
      DK: 'Dánia',
      LT: 'Litvánia',
      LV: 'Lettország',
      EE: 'Észtország',
    },
  },
  cart: {
    newCart: 'Új kosár',
    currentCart: 'Jelenlegi kosár',
    modified: 'módosítva',
    lastSaved: 'Utolsó mentés',
    unsavedChanges: 'mentetlen változás',
    saveCart: 'Kosár mentése',
    loadCart: 'Kosár betöltése',
    deleteCart: 'Kosár törlése',
    startNewCart: 'Új kosár indítása',
    savedCarts: 'Mentett kosarak',
    cartSaved: 'Kosár mentve',
    cartDeleted: 'Kosár törölve',
    confirmDeleteCart: 'Törli a kosarat?\n\nEz a művelet nem vonható vissza.',
    confirmSwitchCart: 'A jelenlegi kosárban mentetlen változtatások vannak.\n\nMásik kosár betöltésével a jelenlegi változtatások elvesznek.\n\nFolytatja?',
    confirmSwitchCartTitle: 'Kosár váltása',
    confirmNewCart: 'A jelenlegi kosárban mentetlen változtatások vannak.\n\nÚj kosár indításával a jelenlegi változtatások elvesznek.\n\nFolytatja?',
    confirmNewCartTitle: 'Új kosár indítása',
    confirmClearCart: 'Kosár ürítése?\n\n{count} tétel kerül eltávolításra.\n\nEz a művelet nem vonható vissza.',
    confirmClearCartTitle: 'Kosár ürítése',
    autoSaved: 'Automatikusan mentve',
    itemsWillBeRemoved: 'tétel kerül eltávolításra',
    changesWillBeLost: 'a változtatások elvesznek',
    continueQuestion: 'Folytatja?',
    cartStatus: 'Kosár állapota',
    cartName: 'Kosár neve',
    cartNamePlaceholder: 'pl.: Hónap végi rendelés',
    cartNameRequired: 'Kérjük, adja meg a kosár nevét',
    saveCartDescription: 'Adjon nevet a jelenlegi kosárnak és mentse el. Később betöltheti.',
    cancelCart: 'Kosár megszakítása',
    proceedToCheckout: 'Tovább a pénztárhoz',
    emptyCart: 'A kosár üres',
    erpDown: 'A rendelési rendszer leállt. Kérjük, próbálkozzon újra később.',
    erpDegraded: 'A rendszer jelenleg instabil. A rendelések meghiúsulhatnak.',
    erpDownSaveHint: 'Mentse el a kosarát, és rendeljen a rendszer helyreállítása után.',
    erpSaveCart: 'Kosár mentése',
  },
  nav: {
    dashboard: 'Vezérlőpult',
    products: 'Termékek',
    orderHistory: 'Rendelések',
    account: 'Fiókadatok',
    bulkImport: 'Masseimport',
  },
  settings: {
    selectLanguage: 'Válasszon nyelvet',
    languagePreferenceSaved: 'A választása mentésre kerül a fiókjában a jövőbeli látogatásokhoz.',
  },
  reorder: {
    allItemsAdded: '{count} tétel hozzáadva a kosárhoz',
    partialSuccess: '{added} tétel hozzáadva. {failed} tételt nem sikerült hozzáadni',
    allItemsFailed: 'Nem sikerült tételeket adni a kosárhoz',
    error: 'Hiba történt az újrarendelés során',
    itemDiscontinued: '{name} ({color}/{size}) megszűnt',
    itemOutOfStock: '{name} ({color}/{size}) elfogyott',
    partialStock: '{name} ({color}/{size}) csak {available} érhető el',
    confirmReorder: 'Újrarendelés megerősítése',
    confirmReorderMessage: 'Hozzáadja a rendelés tételeit a kosárhoz?',
    addingToCart: 'Hozzáadás a kosárhoz...',
    checkingStock: 'Készlet ellenőrzése...',
    checkoutTitle: 'Tételek hozzáadva a kosárhoz',
    checkoutDescription: '{count} tétel került a kosarába. Szeretne a pénztárhoz menni?',
  },
  bulkImport: {
    instructions: 'Hogyan importáljon rendeléseket',
    step1: 'Töltse le a rendeléssablon fájlt',
    step2: 'Töltse ki a rendelési adatokat az SKU és mennyiség megadásával',
    step3: 'Mentse el Excel (.xlsx) vagy CSV fájlként',
    step4: 'Töltse fel a fájlt az alábbi űrlap segítségével',
    step5: 'Tekintse át és erősítse meg a rendelését',
    downloadTemplate: 'Sablon letöltése',
    downloadExcelTemplate: 'Excel sablon letöltése',
    downloadCsvTemplate: 'CSV sablon letöltése',
    formatGuide: 'Fájlformátum útmutató',
    requiredColumns: 'Kötelező oszlopok',
    skuDescription: 'Termék SKU kód',
    quantityDescription: 'Rendelési mennyiség (pozitív egész szám)',
    optionalColumns: 'Opcionális oszlopok',
    notesDescription: 'Belső megjegyzések (pl. rendelésszám, hivatkozás) - csak saját nyilvántartásra',
    formatNote: 'Az első sornak tartalmaznia kell az oszlopfejléceket. Az adatok a második sortól kezdődnek.',
    parseSuccess: 'Sikeresen feldolgozva {count} tétel a fájlból',
    parseError: 'Feldolgozási hiba',
    validationError: 'Validációs hiba',
    validationErrorGuidance: 'Kérjük, kattintson a "{showPreviewButton}" gombra a részletek áttekintéséhez.',
    warnings: 'Figyelmeztetések',
    itemsParsed: 'Sikeresen feldolgozva {count} tétel:',
    andMore: '...és {count} további tétel',
    validationSummary: 'Validációs összefoglaló',
    duplicateSKUs: 'Duplikált SKU-k találhatók',
    skuFormat: 'Az SKU csak betűket, számokat és kötőjeleket tartalmazhat',
    quantityRange: 'A mennyiségnek 1 és 9999 között kell lennie',
    maxRows: 'Maximum 1000 sor engedélyezett',
    rowsSkipped: '{count} sor kihagyva hiba miatt',
    previewTitle: 'Rendelés előnézet',
    previewDescription: 'Tekintse át és szerkessze rendelési adatait a folytatás előtt',
    proceedToCart: 'Hozzáadás a kosárhoz',
    // File parsing messages
    fileEmpty: 'A fájl üres vagy nem tartalmaz adatot',
    fileTooManyRows: 'A fájl túl sok sort tartalmaz ({current}). Maximum engedélyezett: {max}',
    invalidRowFormat: 'Érvénytelen sorformátum',
    missingColumns: 'Hiányzó kötelező oszlopok (SKU és Mennyiség)',
    missingSku: 'Hiányzó SKU',
    invalidSkuFormat: 'Érvénytelen SKU formátum: "{sku}" (kötelező minta: {pattern})',
    skuTooLong: 'Túl hosszú SKU: "{sku}" (maximum 50 karakter)',
    invalidQuantity: 'Érvénytelen mennyiség: "{quantity}" nem szám',
    quantityTooLow: 'A mennyiség túl kevés: {quantity} (minimum: {min})',
    quantityTooHigh: 'A mennyiség túl sok: {quantity} (maximum: {max})',
    notesRequired: 'Megjegyzés mező kötelező',
    noValidData: 'Nem található érvényes adat. Kérjük, ellenőrizze a fájl formátumát.',
    row: 'Sor {row}: {errors}',
    rowErrors: '...és {count} további hiba',
    duplicateSkuInRows: 'Duplikált SKU "{sku}" található a következő sorokban: {rows}',
    quantityExceedsMax: 'Sor {row}: A mennyiség {quantity} meghaladja a megengedett maximumot ({max})',
    quantityBelowMin: 'Sor {row}: A mennyiség {quantity} a kötelező minimum alatt van ({min})',
    // Validation messages
    unsupportedFileFormat: 'Nem támogatott fájlformátum. Kérjük, töltsön fel CSV vagy Excel fájlt.',
    csvParsingErrors: 'CSV feldolgozási hiba történt',
    failedToParseFile: 'Nem sikerült a fájl feldolgozása',
    failedToParseExcel: 'Nem sikerült az Excel fájl feldolgozása',
    failedToReadFile: 'Nem sikerült a fájl beolvasása',
    unknownError: 'Ismeretlen hiba történt',
    totalRows: 'Összes sor',
    valid: 'Érvényes',
    invalid: 'Érvénytelen',
    skipped: 'Kihagyva',
    // SKU validation
    skuValidationError: 'SKU validációs hiba',
    skuValidationFailed: 'Nem sikerült validálni az SKU-kat. Folytathatja, de előfordulhat, hogy egyes tételek nem elérhetők.',
    skuNotFound: 'SKU nem található az adatbázisban',
    skusNotFound: '{count} SKU nem található az adatbázisban',
    itemsHaveInsufficientStock: '{count} tételből nincs elegendő készlet',
    validatingSKUs: 'Tételek validálása...',
    unvalidatedChanges: 'Validálatlan változtatásai vannak. Kérjük, validálja újra, mielőtt a kosárhoz adná.',
    revalidate: 'Újravalidálás',
    validating: 'Validálás...',
    validationSuccess: 'Minden tétel érvényes',
    validationComplete: 'Validálás kész',
    validationResultSummary: '{errors} hiba, {warnings} figyelmeztetés található',
    // Table headers
    actions: 'Műveletek',
    notes: 'Megjegyzések',
    // Status filter
    all: 'Összes',
    hasErrors: 'Hibás',
    // Selection summary
    selected: 'kiválasztva',
    errors: 'hiba',
    // Pagination
    page: 'Oldal: {current} / {total}',
    previous: 'Előző',
    next: 'Következő',
    noResults: 'Nincs eredmény.',
    // Cart integration
    noValidItems: 'Nincs érvényes tétel',
    allItemsHaveErrors: 'Minden tétel validációs hibát tartalmaz. Kérjük, javítsa őket a folytatás előtt.',
    dataLoadingError: 'Adatbetöltési hiba',
    failedToLoadProductData: 'Nem sikerült betölteni a termékadatokat. Kérjük, próbálja újra.',
    itemsAddedToCart: '{count} tétel hozzáadva a kosárhoz',
    itemsAddedMessage: '{count} tétel hozzáadva a kosárhoz',
    someSkusNotFound: '{count} SKU nem található.',
    noItemsAdded: 'Nem lett tétel hozzáadva',
    couldNotFindProducts: 'Nem található termék az SKU-khoz.',
    errorAddingToCart: 'Hiba',
    failedToAddToCart: 'Nem sikerült a tételeket a kosárhoz adni. Kérjük, próbálja újra.',
    addingToCart: 'Hozzáadás a kosárhoz...',
    // File info
    fileSelected: '{name} kiválasztva feldolgozásra',
    fileSize: '{size} bájt',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Sablon letöltése',
    templateWillBeImplemented: 'A sablon letöltése a 7. fázisban lesz elérhető',
    // Additional validation
    validationFailed: 'A validálás sikertelen',
    // Template download
    templateDownloaded: 'Sablon sikeresen letöltve',
    templateDownloadError: 'Nem sikerült letölteni a sablont',
    // Template content
    sheetName: 'Tömeges rendelés',
    instructionsSheetName: 'Instrukciók',
    columnDescriptions: 'Oszlopleírások:',
    columnHeader: 'Oszlop',
    columnRequired: 'Kötelező',
    columnOptional: 'Opcionális',
    columnDescription: 'Leírás',
    templateNotes: 'Megjegyzések:',
    templateNote1: 'Az első sornak pontosan a megadott oszlopfejléceket kell tartalmaznia',
    templateNote2: 'Az adatok a 2. sortól kezdődnek',
    templateNote3: 'Az SKU-nak egyeznie kell a rendszerben lévő termékkódokkal',
    templateNote4: 'A mennyiségnek pozitív egész számnak kell lennie 1 és 9999 között',
    templateNote5: 'Fájlonként maximum 1000 sor engedélyezett',
    templateNote6: 'Mentés .xlsx vagy .csv formátumban',
    stockAvailabilityWarning: 'A tényleges készletelérhetőség a következő pénztár oldalon kerül ellenőrzésre.',
    outOfStock: 'Elfogyott',
    insufficientStock: 'Elégtelen készlet: {available} elérhető, {requested} kért',
  },
  orderExport: {
    export: 'Rendelés exportálása',
    exportOrder: 'Rendelési adatok exportálása',
    exportAsCSV: 'Exportálás CSV-ként',
    exportAsExcel: 'Exportálás Excel-ként',
    exportForReorder: 'Exportálás tömeges importhoz',
    detailed: 'Teljes részletezés',
    simpleFormat: 'Import formátum',
  },
};
